<template>

    <div id="attachments-component">

        <ul class="list-group">
            <li class="list-group-item"
                v-for="attachment in attachments">

                <span class="badge attachment-delete-btn" title="삭제"
                      v-if="mode === 'manager'"
                      @click="deleteAttachment(attachment)"><span class="glyphicon glyphicon-remove"></span></span>

                <a target="_blank"
                   :href="'/attachment/' + attachment.id + '/download'"
                   v-text="attachment.name"></a>
            </li>
            <li class="list-group-item fileupload-item"
                v-if="mode === 'manager'">

                <input :id="'fileupload-' + this._uid" type="file" name="files[]"
                       v-if="canAddAttachment">

                <p class="text-grey text-xs" v-else>추가 가능한 최대 파일 갯수는 {{ max }}개 입니다.</p>
            </li>
        </ul>



    </div>
    
</template>

<script>

    export default {
        name: "attachments",
        props: ['relatedWith', 'relatedId', 'attachmentType', 'attachmentMax', 'attachmentMode'],
        data() {
            return {
                data: [],
                related_with: "",
                related_id: "",
                type: "",
                max: "",
                mode: "",
            }
        },
        created() {
            this.related_with = this.relatedWith;
            this.related_id = this.relatedId;
            this.type = this.attachmentType;
            this.max = this.attachmentMax;
            this.mode = this.attachmentMode;

            if (isNaN(this.max)) {
                this.max = 4;
            }

            if (this.mode !== "manager" && this.mode !== "list") {
                this.mode = "list";
            }

            this.getAttachments();

            this.initFileUpload(this.related_with, this.related_id, this.type);
        },
        mounted() {
            this.initFileUpload(this.related_with, this.related_id, this.type);
        },
        updated() {
            this.initFileUpload(this.related_with, this.related_id, this.type);
        },
        watch: {
            attachmentMode(new_mode, old_mode) {
                this.mode = this.attachmentMode;
            },
            relatedWith(new_relatedWith, old_relatedWith) {
                this.related_id = this.relatedId;
                this.getAttachments();
            },
            relatedId(new_relatedId, old_relatedId) {
                this.related_id = this.relatedId;
                this.getAttachments();
            }
        },
        computed: {
            attachments() {
                return this.data;
            },
            canAddAttachment() {
                return this.max > this.attachments.length;
            }
        },
        methods: {

            getAttachments() {
                $.ajax({
                    url: "/attachment",
                    method: "get",
                    data: {
                        related_with: this.related_with,
                        related_id: this.related_id,
                        type: this.type,
                        is_ajax: true,
                    }
                })
                .done((response) => {
                    this.data = response
                })
            },
            storeAttachment() {

            },
            deleteAttachment(attachment) {

                if ( ! confirm('"' + attachment.name + '" 파일을 정말 삭제하시겠습니까?')) return;

                $.ajax({
                    url: "/attachment/" + attachment.id,
                    method: 'post',
                    data: { _method: 'delete' }
                })
                .done((response) => {
                    this.getAttachments();
                })
            },
            initFileUpload(related_with, related_id, type) {

                var that = this;

                $('#fileupload-' + this._uid).fileupload({
                    url: "/attachment",
                    type: "post",
                    dataType: 'json',
                    formData: {
                        related_with: related_with,
                        related_id: related_id,
                        type: type
                    },
                    done(e, data) {
                        console.log("done: " + this.related_with);
                    },
                    always(e, data) {
                        that.getAttachments();
                    }
                });

            }

        }
    }
</script>

<style scoped>
    .attachment-delete-btn {
        cursor: pointer;
    }
    .fileupload-item {
        background-color: #f6f6f6;
    }
</style>


// WEBPACK FOOTER //
// src/Attachments.vue